import React, { FC, useMemo } from 'react';

import NotificationBanner from '~/components/atoms/NotificationBanner';
import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import {
  GB_FEATURE_KEYS,
  LiveUserNotificationPlaces,
} from '~/services/abTests/features';

type Props = {
  place: LiveUserNotificationPlaces;
  children: React.ReactNode;
};

const LiveNotificationMiddleware: FC<Props> = ({ place, children }) => {
  const liveNotifications = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.LIVE_USER_NOTIFICATIONS,
  );

  const pageNotification = useMemo(() => {
    return liveNotifications?.find((msg) => msg.place === place);
  }, [liveNotifications, place]);

  return (
    <>
      {pageNotification && (
        <NotificationBanner
          message={pageNotification.message}
          variant={pageNotification.variant}
        />
      )}
      {children}
    </>
  );
};

export default LiveNotificationMiddleware;
